import React, { useEffect, useCallback } from "react";

const COOKIEYES_CLIENT_ID = "7c84296eb51527f187b7f8ddf8569b17";
const COOKIEYES_POLICY_SRC = `https://cdn-cookieyes.com/client_data/${COOKIEYES_CLIENT_ID}/cookie-policy/script.js`;
const SCRIPT_ID = "cookieyes-policy-script";

export default function CookiePolicyPage() {
  const containerStyle = {
    maxWidth: "850px",
    margin: "0 auto",
    padding: "40px 20px",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    lineHeight: 1.6,
    color: "#222",
  };

  const headingStyle = {
    marginTop: "32px",
  };

  const buttonStyle = {
    marginTop: "16px",
    padding: "10px 18px",
    fontSize: "14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    background: "#f7f7f7",
    cursor: "pointer",
  };

  const homeLinkStyle = {
  display: "inline-block",
  marginBottom: "20px",
  color: "#2b6cb0",
  textDecoration: "none",
  fontSize: "14px",
};

  const buttonHoverStyle = {
    background: "#eee",
  };

  const handleMouseOver = (e) => {
    e.currentTarget.style.textDecoration = "underline";
    };

    const handleMouseOut = (e) => {
    e.currentTarget.style.textDecoration = "none";
    };

  const openPreferences = useCallback(() => {
    // @ts-ignore
    if (typeof window !== "undefined" && window?.CKY?.openPreferences) {
      // @ts-ignore
      window.CKY.openPreferences();
    } else if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

//   useEffect(() => {
//     if (typeof document === "undefined") return;

//     if (document.getElementById(SCRIPT_ID)) return;

//     const script = document.createElement("script");
//     script.id = SCRIPT_ID;
//     script.src = COOKIEYES_POLICY_SRC;
//     script.async = true;

//     document.body.appendChild(script);

//     return () => {
//       const s = document.getElementById(SCRIPT_ID);
//       if (s?.parentNode) s.parentNode.removeChild(s);
//     };
//   }, []);

  return (
    <div style={containerStyle}>
        <a
        href="/"
        style={homeLinkStyle}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        >
        ← Return to Home
        </a>
      <h1>Cookie Policy</h1>

      <p>
        <strong>Effective date:</strong> February 13, 2026
        <br />
        <strong>Last updated:</strong> February 13, 2026
      </p>

      <h2 style={headingStyle}>What are cookies?</h2>

      <p>
        This Cookie Policy explains what cookies are, how we use them, the types
        of cookies we use (i.e., the information we collect using cookies and how
        that information is used), and how to manage your cookie settings.
      </p>

      <p>
        Cookies are small text files stored on your device when a website loads
        in your browser. These cookies help ensure the website functions
        properly, enhance security, provide a better user experience, and help us
        understand how the website performs.
      </p>

      <h2 style={headingStyle}>Types of cookies we use</h2>

      {/* CookieYes injects the cookie audit table here */}
      <div className="cky-audit-table-element" />

      <h2 style={headingStyle}>Manage cookie preferences</h2>

      <button
        onClick={openPreferences}
        style={buttonStyle}
        onMouseOver={(e) => (e.currentTarget.style.background = "#eee")}
        onMouseOut={(e) => (e.currentTarget.style.background = "#f7f7f7")}
      >
        Consent Preferences
      </button>

      <p style={{ marginTop: "16px" }}>
        You can modify your cookie settings at any time by clicking the
        <strong> “Consent Preferences” </strong> button above. This allows you to
        revisit the cookie banner and update your preferences or withdraw
        consent.
      </p>

      <p>
        Additionally, most web browsers allow you to control cookies through
        their settings. To learn more about cookies and how to manage them, visit
        your browser’s help documentation.
      </p>
    </div>
  );
}
